/*  Shared  */
import ObjectPicker from 'application/Shared/Components/Pickers/Components/ObjectPicker';
import Core from 'application/Shared/Helpers/Functions';
import Requests from 'application/Shared/Requests/Handler';

/*  NPM  */
import axios from 'axios';

/*  Objects  */
import BusinessOwnerFunctions from 'objects/functions/BusinessOwner';

/*  React  */
import React, { Component } from 'react';
import { withRouter } from 'router/withRouter';

class BusinessOwnerPicker extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loaded: false,
            objectPayload: []
        };

        /* requests */
        this.requests = new Requests();
    }

    componentDidMount() {
        this.load();
    }

    componentWillUnmount() {
        this.unload();
    }

    load = async () => {
        const { hideUsersInOrganization, match } = this.props;
        const { clientId } = match.params;

        const params = { firstName: '*', size: -1 };
        if (clientId) {
            params.platformTenantId = clientId;
            params.includeClients = true;
        }

        let payload = [];

        if (
            !(
                Core.isset(this.props, 'hideUsersInOrganization') &&
                hideUsersInOrganization
            )
        ) {
            try {
                const usersResponse = await axios.get('/user', {
                    cancelToken: this.requests.token(),
                    params
                });

                const owners = usersResponse?.data?.data;

                const augmentedOwners = owners.map((owner) => {
                    const name =
                        owner.firstName || owner.lastName
                            ? `${owner.firstName} ${owner.lastName}`
                            : owner.email;
                    return {
                        ...owner,
                        name
                    };
                });

                payload = augmentedOwners.sort((a, b) =>
                    `${a.lastName}`.localeCompare(b.lastName)
                );
            } catch (e) {
                return;
            }
        }

        payload.unshift(BusinessOwnerFunctions.managedByPartnerValue);
        payload.unshift(BusinessOwnerFunctions.managed3rdPartyValue);
        payload.unshift(BusinessOwnerFunctions.noBusinessOwnerRequiredValue);

        this.setState({ loaded: true, objectPayload: payload });
    };

    unload = () => {
        this.requests.cancel();
    };

    render() {
        const { managed3rdParty, managedByPartner, noBusinessOwnerRequired } =
            this.props;
        let { value } = this.props;
        const { loaded, objectPayload } = this.state;

        if (!loaded) {
            return null;
        }

        if (noBusinessOwnerRequired) {
            value = BusinessOwnerFunctions.noBusinessOwnerRequiredValue.name;
        }

        if (managedByPartner) {
            value = BusinessOwnerFunctions.managedByPartnerValue.name;
        }

        if (managed3rdParty) {
            value = BusinessOwnerFunctions.managed3rdPartyValue.name;
        }

        if (value == null) {
            value = BusinessOwnerFunctions.notAssigned;
        }

        return (
            <ObjectPicker
                {...this.props}
                disableClearable
                value={value}
                title="Business Owner"
                objectPayload={objectPayload}
                objectNameField="name"
            />
        );
    }
}

export default withRouter(BusinessOwnerPicker);
